import React from "react";

export default function Footer() {
  return (
    <>
      <footer className="">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left">
            <div className="w-full lg:w-4/12 px-4">
              <div className="w-full mb-5">
                <img
                  src="https://wpbingosite.com/wordpress/digic/wp-content/webp-express/webp-images/uploads/2021/03/logo-1.png.webp"
                  className="attachment-full w-24"
                />
              </div>
              <p className="mb-4">
                If you have any question, please contact us at <br />
                <a href="#" className="text-red-600">
                  support@toora.com
                </a>
              </p>

              <div className="mb-2">
                <div className="elementor-icon-box-wrapper flex items-center">
                  <div className="elementor-icon-box-icon inline-flex mr-3">
                    <span className="elementor-icon elementor-animation- text-lg fill-gray-900 w-6 h-6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Capa_1"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <path d="m512 234.836-99.35-127.169h-56.316v-42.667h-356.334v328.667h60.409c4.666 30.165 30.806 53.333 62.258 53.333s57.592-23.168 62.258-53.333h142.151c4.665 30.165 30.806 53.333 62.257 53.333s57.592-23.168 62.258-53.333h60.409zm-89.667 149.164c0 18.196-14.804 33-33 33s-33-14.804-33-33 14.804-33 33-33 33 14.804 33 33zm-266.666 0c0 18.196-14.804 33-33 33s-33-14.804-33-33 14.804-33 33-33 33 14.804 33 33zm-33-63c-27.624 0-51.135 17.879-59.614 42.667h-33.053v-98h205.314l29.905-104.667h-235.219v-66h296.333v268.667h-144.052c-8.479-24.788-31.99-42.667-59.614-42.667zm-92.666-85.333v-44.667h195.447l-12.762 44.667zm359.332 85.333c-12.093 0-23.396 3.432-33 9.363v-75.363h125.667v108.667h-33.053c-8.478-24.788-31.99-42.667-59.614-42.667zm-33-96v-87.333h41.684l68.23 87.333z" />
                        </g>
                      </svg>
                    </span>
                  </div>
                  <div className="elementor-icon-box-content text-gray-900">
                    <p className="elementor-icon-box-description">
                      30 Buttonwood St.Pataskala OH 43062
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <div className="elementor-icon-box-wrapper flex items-center">
                  <div className="elementor-icon-box-icon inline-flex mr-3">
                    <span className="elementor-icon elementor-animation- text-lg fill-gray-900 w-6 h-6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Capa_1"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <path d="m512 234.836-99.35-127.169h-56.316v-42.667h-356.334v328.667h60.409c4.666 30.165 30.806 53.333 62.258 53.333s57.592-23.168 62.258-53.333h142.151c4.665 30.165 30.806 53.333 62.257 53.333s57.592-23.168 62.258-53.333h60.409zm-89.667 149.164c0 18.196-14.804 33-33 33s-33-14.804-33-33 14.804-33 33-33 33 14.804 33 33zm-266.666 0c0 18.196-14.804 33-33 33s-33-14.804-33-33 14.804-33 33-33 33 14.804 33 33zm-33-63c-27.624 0-51.135 17.879-59.614 42.667h-33.053v-98h205.314l29.905-104.667h-235.219v-66h296.333v268.667h-144.052c-8.479-24.788-31.99-42.667-59.614-42.667zm-92.666-85.333v-44.667h195.447l-12.762 44.667zm359.332 85.333c-12.093 0-23.396 3.432-33 9.363v-75.363h125.667v108.667h-33.053c-8.478-24.788-31.99-42.667-59.614-42.667zm-33-96v-87.333h41.684l68.23 87.333z" />
                        </g>
                      </svg>
                    </span>
                  </div>
                  <div className="elementor-icon-box-content text-gray-900">
                    <p className="elementor-icon-box-description">
                      (+1)-613-333-0101
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 lg:mb-0 mb-6">
                <button
                  className="bg-white text-lightBlue-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-twitter"></i>
                </button>
                <button
                  className="bg-white text-lightBlue-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-facebook-square"></i>
                </button>
                <button
                  className="bg-white text-pink-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-dribbble"></i>
                </button>
                <button
                  className="bg-white text-blueGray-800 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-github"></i>
                </button>
              </div>
            </div>
            <div className="w-full lg:w-5/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <div className="w-full lg:w-6/12 px-4">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Pages
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.creative-tim.com/presentation?ref=nr-footer"
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://blog.creative-tim.com?ref=nr-footer"
                      >
                        Blog
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.github.com/creativetimofficial?ref=nr-footer"
                      >
                        Github
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.creative-tim.com/bootstrap-themes/free?ref=nr-footer"
                      >
                        Free Products
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Other Resources
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://github.com/creativetimofficial/notus-react/blob/main/LICENSE.md?ref=nr-footer"
                      >
                        MIT License
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/terms?ref=nr-footer"
                      >
                        Terms & Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/privacy?ref=nr-footer"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/contact-us?ref=nr-footer"
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-3/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
              <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    NEWSLETTER
                  </span>
                  <p className="mb-2">
                    Subscribe to the weekly newsletter for all the latest
                    updates
                  </p>
                  <div className="wpbingo-newsletter newsletter-default">
                    <div className="content-newsletter">
                      <span className="wpcf7-form-control-wrap">
                        <input
                          type="email"
                          name="your-email"
                          className=""
                          placeholder="Your email address..."
                          defaultValue=""
                        />
                      </span>
                      <span className="clearfix">
                        <input
                          type="submit"
                          defaultValue="SUBSCRIBE"
                          className="wpcf7-form-control wpcf7-submit"
                        />
                        <span className="ajax-loader" />
                      </span>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <hr className="my-6 border-blueGray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-blueGray-500 font-semibold py-1">
              © {new Date().getFullYear()} Digic Electronic Store
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* <footer className="relative bg-blueGray-200 pt-8 pb-6">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left">
            <div className="w-full lg:w-6/12 px-4">
              <h4 className="text-3xl font-semibold">Let's keep in touch!</h4>
              <h5 className="text-lg mt-0 mb-2 text-blueGray-600">
                Find us on any of these platforms, we respond 1-2 business days.
              </h5>
              <div className="mt-6 lg:mb-0 mb-6">
                <button
                  className="bg-white text-lightBlue-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-twitter"></i>
                </button>
                <button
                  className="bg-white text-lightBlue-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-facebook-square"></i>
                </button>
                <button
                  className="bg-white text-pink-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-dribbble"></i>
                </button>
                <button
                  className="bg-white text-blueGray-800 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-github"></i>
                </button>
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Useful Links
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.creative-tim.com/presentation?ref=nr-footer"
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://blog.creative-tim.com?ref=nr-footer"
                      >
                        Blog
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.github.com/creativetimofficial?ref=nr-footer"
                      >
                        Github
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.creative-tim.com/bootstrap-themes/free?ref=nr-footer"
                      >
                        Free Products
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Other Resources
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://github.com/creativetimofficial/notus-react/blob/main/LICENSE.md?ref=nr-footer"
                      >
                        MIT License
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/terms?ref=nr-footer"
                      >
                        Terms & Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/privacy?ref=nr-footer"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/contact-us?ref=nr-footer"
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-6 border-blueGray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-blueGray-500 font-semibold py-1">
                Copyright © {new Date().getFullYear()} Notus React by{" "}
                <a
                  href="https://www.creative-tim.com?ref=nr-footer"
                  className="text-blueGray-500 hover:text-blueGray-800"
                >
                  Creative Tim
                </a>
                .
              </div>
            </div>
          </div>
        </div>
      </footer> */}
    </>
  );
}
